import React from 'react';
import { Link } from 'react-router-dom';
import styles from './styles/occThankYou.scss';
import { useOCC } from './context/occContext';
import FormattedRichMessage from '../common/FormattedRichMessages';
const OCCThankYouPage = () => {
  const {
    emailObj
  } = useOCC();

  // 🔹 For now just using param or fallback
  //   const email = emailObj?.maskedEmail || 'your email';

  // 🔹 Simple masking (can improve later)
  //   const maskEmail = (emailId) => {
  //     if (!emailId || !emailId.includes('@')) return emailId;

  //     const [name, domain] = emailId.split('@');
  //     const maskedName =
  //       name.length > 2
  //         ? `${name[0]}*****${name[name.length - 1]}`
  //         : `${name[0]}***`;

  //     return `${maskedName}@${domain}`;
  //   };

  return /*#__PURE__*/React.createElement("div", {
    className: styles.occ_thankyou_container
  }, /*#__PURE__*/React.createElement("h1", {
    className: styles.occ_title
  }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "Thankyou"
  })), /*#__PURE__*/React.createElement("p", {
    className: styles.occ_subtitle
  }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "thanks.subtitle",
    values: {
      email: emailObj === null || emailObj === void 0 ? void 0 : emailObj.maskedEmail
    }
  })), /*#__PURE__*/React.createElement("p", {
    className: styles.occ_text
  }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "thanks.description"
  })), /*#__PURE__*/React.createElement("p", {
    className: styles.occ_text
  }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "thanks.ulTitle"
  })), /*#__PURE__*/React.createElement("ul", {
    className: styles.occ_list
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "thanks.note1"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "thanks.note2"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "thanks.note3"
  }))), /*#__PURE__*/React.createElement("p", {
    className: styles.occ_text
  }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "thanks.additionalText"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.occ_links
  }, /*#__PURE__*/React.createElement(Link, {
    to: "http://www212.americanexpress.com/dsmlive/dsm/dom/us/en/privacystatement/internetprivacystatement.do?vgnextoid=f25533fadb4ca110VgnVCM100000defaad94RCRD"
  }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "thanks.linkText1"
  })), /*#__PURE__*/React.createElement(Link, {
    to: "http://www212.americanexpress.com/dsmlive/dsm/dom/us/addustoyouraddressbook.do?vgnextoid=46c001cc1e65b110VgnVCM100000defaad94RCRD"
  }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "thanks.linkText2"
  })), /*#__PURE__*/React.createElement(Link, {
    to: "http://www.americanexpress.com/summaryofaccounts"
  }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "thanks.linkText3"
  }))));
};
export default OCCThankYouPage;